import { ReservedResourcePhase } from 'src/api/api.generated'
import { ReservedResourceF } from '../types/reservation-detail.types'
import { isInAgeRange } from 'src/utils/date'

type GuestOccupancySplitted = { notOutGuests: { adults: number; children: number }; outGuests: { adults: number; children: number } }

/**
 * Splits occupancy, distinguish between adults and children that has checked out or not.
 * @param reservedResource
 * @returns
 */
export function splitGuestOccupancy(reservedResource: ReservedResourceF): GuestOccupancySplitted {
  const defaultValue: GuestOccupancySplitted = { notOutGuests: { adults: 0, children: 0 }, outGuests: { adults: 0, children: 0 } }
  const childOccupancyIds = (reservedResource?.childOccupancies ?? []).map((co) => co.child.id)

  return (
    reservedResource.guestOccupancies?.reduce((result: GuestOccupancySplitted, current) => {
      if (
        reservedResource.childOccupancies &&
        reservedResource.childOccupancies.some((co) => current.guest.person?.birthDate && isInAgeRange(current.guest.person.birthDate, co.child.minAge, co.child.maxAge))
      ) {
        if (current.phase !== ReservedResourcePhase.CHECKOUT) {
          return { ...result, notOutGuests: { ...result.notOutGuests, children: result.notOutGuests.children + 1 } }
        } else {
          return { ...result, outGuests: { ...result.outGuests, children: result.outGuests.children + 1 } }
        }
      } else {
        if (current.phase !== ReservedResourcePhase.CHECKOUT) {
          return { ...result, notOutGuests: { ...result.notOutGuests, adults: result.notOutGuests.adults + 1 } }
        } else {
          return { ...result, outGuests: { ...result.outGuests, adults: result.outGuests.adults + 1 } }
        }
      }
    }, defaultValue) ?? defaultValue
  )
}

export function guestReductionOperationType(reservedResource: ReservedResourceF): 'CHILDREN_REDUCTION' | 'ADULTS_REDUCTION' | 'CHILD_CANCEL' | 'ADULT_CANCEL' {
  let operationType: 'CHILDREN_REDUCTION' | 'ADULTS_REDUCTION' | 'CHILD_CANCEL' | 'ADULT_CANCEL' | undefined = undefined

  const existGuestOccupancy = (reservedResource.guestOccupancies?.length ?? 0) > 0

  const isChildGuest = !existGuestOccupancy || reservedResource.children >= 1
  const splittedGo = splitGuestOccupancy(reservedResource)

  if (isChildGuest) {
    if ((splittedGo.outGuests.children < 1 && splittedGo.notOutGuests.children === reservedResource.children) || splittedGo.notOutGuests.children === 0 || !existGuestOccupancy) {
      operationType = 'CHILDREN_REDUCTION'
    } else {
      operationType = 'CHILD_CANCEL'
    }
  } else {
    if (splittedGo.outGuests.adults < 1 && splittedGo.notOutGuests.adults === reservedResource.adults) {
      operationType = 'ADULTS_REDUCTION'
    } else {
      operationType = 'ADULT_CANCEL'
    }
  }
  return operationType
}
